var LocationsComponentModule = /** @class */ (function () {
    function LocationsComponentModule() {
    }
    return LocationsComponentModule;
}());
export { LocationsComponentModule };
